webpackJsonp([244135725421412],{

/***/ 1024:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"codex","mid_text_1":null,"sirlins_filename":"0015_hired_stomper.jpg","type":"Unit","subtype":"Lizardman","cost":4,"ATK":4,"HP":3,"rules_text_1":"Arrives: Deal 3 damage to a unit. (Heroes aren't units.)","rules_text_2":null,"rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Hired Stomper","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":"\"Ragoroggggg! Hssssss!\"","color":"Neutral","spec":"Bashing","bottom":"Tech II","rulings":[],"keywords":[],"slug":"hired_stomper"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"hired_stomper","keywords":[],"imageRegex":"/hired_stomper.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-hired-stomper-90f77979b6b91fb86b88.js